import React from "react";
import {useAuth} from '../util/auth';
import SigninConditionalRenderer from './SigninConditionalRenderer';

type VideoEmbedProps = {
    url: string;
    thumb?: string;
    authRequired?: boolean;
}
function VideoEmbed(props: VideoEmbedProps) {
    const auth = useAuth();
    const authRequired = props.authRequired !== undefined ? props.authRequired : !!props.thumb;

    return (
        <SigninConditionalRenderer
            title="You must be logged in to access this content"
            buttonText="Log in to continue"
            mode="overlay"
            authRequired={authRequired}
        >
            <figure className="aspect-video w-full mb-0">
                {authRequired && !auth.isAuthenticated ? (
                    <img src={props.thumb} alt="" />
                ) : (
                    <iframe
                        title="Video"
                        style={{height: '100%', width: '100%'}}
                        src={props.url}
                        allowFullScreen={true}
                        frameBorder={0}
                    />
                )}
            </figure>
        </SigninConditionalRenderer>
    );
}

export default VideoEmbed;
